import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table } from 'react-bootstrap';
import Sidebar from './Sidebar';
import configAdmin from './configAdmin.json';
import { getPageContent, updatePageContent } from './apiCalls';
import ToastConfirmation from './ToastConfirmation';

const { MIGRATIONPAGE_CODE } = configAdmin

export default function MigrationEdit() {
  const [showToaster, setShowToaster] = useState(false);
  const [pageContent, setPageContent] = useState({});
  const [pageContentFormData, setPageConentFormData] = useState({});

  useEffect(() => {
      getPageContent(setPageContent, MIGRATIONPAGE_CODE);
  }, []);

  const populationWeightsConfig = pageContent?.additionalData?.populationWeights || { enabled: false, items: [] };
  const populationWeightItems = populationWeightsConfig.items || [];

  const handlePopulationWeightToggle = (isEnabled) => {
    setPageContent((prevContent) => {
      const previous = prevContent || {};
      const additionalData = previous.additionalData || {};
      const currentWeights = additionalData.populationWeights || { enabled: false, items: [] };
      const currentItems = Array.isArray(currentWeights.items) ? currentWeights.items : [];
      const items = isEnabled
        ? (currentItems.length > 0 ? currentItems : [{ label: '', value: '' }])
        : currentItems;

      return {
        ...previous,
        additionalData: {
          ...additionalData,
          populationWeights: {
            enabled: isEnabled,
            items
          }
        }
      };
    });
  };

  const handleAddPopulationWeight = () => {
    setPageContent((prevContent) => {
      const previous = prevContent || {};
      const additionalData = previous.additionalData || {};
      const currentWeights = additionalData.populationWeights || { enabled: true, items: [] };
      const currentItems = Array.isArray(currentWeights.items) ? currentWeights.items : [];

      return {
        ...previous,
        additionalData: {
          ...additionalData,
          populationWeights: {
            enabled: currentWeights.enabled !== undefined ? currentWeights.enabled : true,
            items: [...currentItems, { label: '', value: '' }]
          }
        }
      };
    });
  };

  const handlePopulationWeightItemChange = (index, field, newValue) => {
    setPageContent((prevContent) => {
      const previous = prevContent || {};
      const additionalData = previous.additionalData || {};
      const currentWeights = additionalData.populationWeights || { enabled: false, items: [] };
      const currentItems = Array.isArray(currentWeights.items) ? currentWeights.items : [];

      const updatedItems = currentItems.map((item, itemIndex) => {
        if (itemIndex === index) {
          return {
            ...item,
            [field]: newValue
          };
        }
        return item;
      });

      return {
        ...previous,
        additionalData: {
          ...additionalData,
          populationWeights: {
            enabled: currentWeights.enabled !== undefined ? currentWeights.enabled : false,
            items: updatedItems
          }
        }
      };
    });
  };

  const handleRemovePopulationWeight = (index) => {
    setPageContent((prevContent) => {
      const previous = prevContent || {};
      const additionalData = previous.additionalData || {};
      const currentWeights = additionalData.populationWeights || { enabled: false, items: [] };
      const currentItems = Array.isArray(currentWeights.items) ? currentWeights.items : [];

      return {
        ...previous,
        additionalData: {
          ...additionalData,
          populationWeights: {
            enabled: currentWeights.enabled !== undefined ? currentWeights.enabled : false,
            items: currentItems.filter((item, itemIndex) => itemIndex !== index)
          }
        }
      };
    });
  };

  const submitForm = () => {
    const mainConfigformDataSubmit = {
      ...pageContent,
      ...pageContentFormData
    }

    updatePageContent(mainConfigformDataSubmit, MIGRATIONPAGE_CODE);
    setShowToaster(true);
  };

  const formContent = (
    <Form>
      <Form.Group className="admin-content-group">
      <Form.Label className="admin-content-form-label">Titulo</Form.Label>
      <Form.Control
          placeholder="Titulo"
          defaultValue={ pageContent?.title && pageContent.title }
          onChange={ (e) => {
            setPageConentFormData({
                ...pageContentFormData,
                title: e.target.value
            });
          } }  
        />
      </Form.Group>

      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Contenido</Form.Label>
        <Form.Control
          as="textarea"
          rows={10}
          defaultValue={ pageContent?.content && pageContent.content }
          onChange={ (e) => {
            setPageConentFormData({
                ...pageContentFormData,
                content: e.target.value
            });
            } } 
        />
      </Form.Group>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>

    </Form>
  )

  const formPopulationWeights = (
    <Form>
      <Form.Group className="admin-content-group">
        <Form.Check
          id="population-weight-enabled"
          type="switch"
          label="Habilitar ponderador de población"
          checked={ populationWeightsConfig.enabled }
          onChange={(e) => {
            handlePopulationWeightToggle(e.target.checked);
          }}
        />
      </Form.Group>
      { populationWeightsConfig.enabled && (
        <Form.Group className="admin-content-group">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Etiqueta</th>
                <th>Nombre de variable</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {populationWeightItems.length === 0 && (
                <tr>
                  <td colSpan={4}>No hay ponderadores definidos.</td>
                </tr>
              )}
              {populationWeightItems.map((item, itemIndex) => (
                <tr key={`population-weight-${itemIndex}`}>
                  <td>{itemIndex + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta"
                      value={ item.label || '' }
                      onChange={(e) => {
                        handlePopulationWeightItemChange(itemIndex, 'label', e.target.value);
                      }}
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Nombre de variable"
                      value={ item.value || '' }
                      onChange={(e) => {
                        handlePopulationWeightItemChange(itemIndex, 'value', e.target.value);
                      }}
                    />
                  </td>
                  <td>
                    <Button
                      type="button"
                      className="admin-delete-item-button"
                      onClick={() => { handleRemovePopulationWeight(itemIndex); }}
                    >
                      Eliminar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Button
            type="button"
            className="odisea-form-button-submit"
            onClick={() => { handleAddPopulationWeight(); }}
          >
            Agregar ponderador
          </Button>
        </Form.Group>
      )}
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>
    </Form>
  );

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
            <Card>
              <Card.Header> Contenido de migración </Card.Header>
              <Card.Body>{ formContent }</Card.Body>
            </Card>
            <Card>
              <Card.Header> Ponderadores de población </Card.Header>
              <Card.Body>{ formPopulationWeights }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
